module.exports = __webpack_public_path__ + "static/audrey-wide-5a5b0f29e1aa1c9054e85bc427d62395.png";